module.exports = __webpack_public_path__ + "img/svg/attention.50f536b7b9ab64aaad10a420c3f10d70.svg";